import React, { useState } from "react";
import {
  Box,
  TextField,
  IconButton,
  Typography,
  InputAdornment,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

interface NomeSobrenomeFormProps {
  nome: string;
  sobrenome: string;
  onChangeNome: (value: string) => void;
  onChangeSobrenome: (value: string) => void;
}

const EditableField: React.FC<{
  label: string;
  value: string;
  onChange: (v: string) => void;
}> = ({ label, value, onChange }) => {
  const [editing, setEditing] = useState(false);

  return (
    <Box sx={{ width: "100%", maxWidth: 350 }}>
      <Typography
        sx={{ color: "#0A0C33", fontSize: 16, fontWeight: 500, mb: 1 }}
      >
        {label}
      </Typography>
      <TextField
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        InputProps={{
          readOnly: !editing,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setEditing(!editing)}
                edge="end"
                sx={{ color: "#0A0C33" }}
              >
                <EditIcon />
              </IconButton>
            </InputAdornment>
          ),
          style: !editing
            ? { fontStyle: "italic", color: "#0A0C33", fontWeight: 400 }
            : { color: "#0A0C33", fontWeight: 400 },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            background: "#fff",
            fontStyle: !editing ? "italic" : "normal",
          },
        }}
        onBlur={() => setEditing(false)}
      />
    </Box>
  );
};

const NomeSobrenomeForm: React.FC<NomeSobrenomeFormProps> = (
  props: NomeSobrenomeFormProps
) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        display: "flex",
        gap: isMobile ? 1 : 4,
        alignItems: "flex-start",
        marginLeft: isMobile ? 2 : 0,
        marginRight: isMobile ? 2 : 0,
      }}
    >
      <EditableField
        label="Nome:"
        value={props.nome}
        onChange={props.onChangeNome}
      />
      <EditableField
        label="Sobrenome:"
        value={props.sobrenome}
        onChange={props.onChangeSobrenome}
      />
    </Box>
  );
};

export default NomeSobrenomeForm;
